export const underwearPromotionQueryKeys = {
  all: ['underwear-promotions'] as const,
};
